"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetFormatLabels = void 0;
const _ = require("lodash");
exports.assetFormatLabels = ['imageService', 'assetFormats', (imageService, assetFormats) => {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'modules/images/directives/assetformatlabels.tpl.html',
            scope: {
                image: '='
            },
            link: (scope, element, attrs) => {
                scope.assetFormats = assetFormats;
                scope.imageUrls = {};
                scope.hasAssetFormat = (assetFormat) => {
                    if (!scope.image)
                        return false;
                    return scope.image.hasAssetFormat(assetFormat);
                };
                scope.$watch('image', (image) => {
                    if (!image) {
                        scope.imageUrls = {};
                    }
                    else {
                        _.each(scope.assetFormats, (assetFormat) => {
                            if (image.hasAssetFormat(assetFormat)) {
                                scope.imageUrls[assetFormat] = imageService.getImageUrl(image.id, assetFormat);
                            }
                        });
                    }
                });
            }
        };
    }];
